// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__139Ed","title":"styles_title__32gBw"};